import { defineStore } from 'pinia'

const arrears = [
  {
    id: 1,
    invoiceNo: 'INV-2026-0003',
    residentName: 'นที วรากร',
    unitCode: 'B-203',
    building: 'อาคาร B',
    billingMonth: 'กุมภาพันธ์ 2026',
    dueDate: '2026-02-28',
    overdueDays: 35,
    agingGroup: '31_60',
    principalAmount: 2500,
    penaltyAmount: 700,
    totalOutstanding: 3200,
    contactStatus: 'contacted',
    lastReminderDate: '2026-03-20',
    note: 'ติดตามแล้ว 1 ครั้ง ลูกบ้านแจ้งจะชำระปลายเดือน',
  },
  {
    id: 2,
    invoiceNo: 'INV-2026-0006',
    residentName: 'จิราพร บุญมี',
    unitCode: 'E-402',
    building: 'อาคาร E',
    billingMonth: 'มีนาคม 2026',
    dueDate: '2026-03-31',
    overdueDays: 3,
    agingGroup: '1_30',
    principalAmount: 1900,
    penaltyAmount: 600,
    totalOutstanding: 2500,
    contactStatus: 'new',
    lastReminderDate: null,
    note: 'ยังไม่ได้ดำเนินการติดตาม',
  },
  {
    id: 3,
    invoiceNo: 'INV-2026-0008',
    residentName: 'ชัยวัฒน์ ทองสุข',
    unitCode: 'H-501',
    building: 'อาคาร H',
    billingMonth: 'มีนาคม 2026',
    dueDate: '2026-03-31',
    overdueDays: 68,
    agingGroup: '61_90',
    principalAmount: 3200,
    penaltyAmount: 1800,
    totalOutstanding: 5000,
    contactStatus: 'escalated',
    lastReminderDate: '2026-03-25',
    note: 'ยอดค้างสะสมสูง ต้องติดตามแบบเร่งด่วน',
  },
  {
    id: 4,
    invoiceNo: 'INV-2026-0011',
    residentName: 'วสันต์ เกียรติยศ',
    unitCode: 'F-208',
    building: 'อาคาร F',
    billingMonth: 'มกราคม 2026',
    dueDate: '2026-01-31',
    overdueDays: 92,
    agingGroup: '90_plus',
    principalAmount: 4100,
    penaltyAmount: 900,
    totalOutstanding: 5000,
    contactStatus: 'legal_review',
    lastReminderDate: '2026-03-15',
    note: 'ส่งเรื่องให้ฝ่ายบริหารพิจารณาแล้ว',
  },
  {
    id: 5,
    invoiceNo: 'INV-2026-0012',
    residentName: 'พรทิพย์ สกุลดี',
    unitCode: 'G-109',
    building: 'อาคาร G',
    billingMonth: 'มีนาคม 2026',
    dueDate: '2026-03-31',
    overdueDays: 9,
    agingGroup: '1_30',
    principalAmount: 1200,
    penaltyAmount: 0,
    totalOutstanding: 1200,
    contactStatus: 'promise_to_pay',
    lastReminderDate: '2026-04-01',
    note: 'ลูกบ้านรับปากจะชำระภายใน 7 วัน',
  },
  {
    id: 6,
    invoiceNo: 'INV-2026-0013',
    residentName: 'สุดา รุ่งเรือง',
    unitCode: 'A-102',
    building: 'อาคาร A',
    billingMonth: 'มีนาคม 2026',
    dueDate: '2026-03-31',
    overdueDays: 14,
    agingGroup: '1_30',
    principalAmount: 900,
    penaltyAmount: 0,
    totalOutstanding: 900,
    contactStatus: 'contacted',
    lastReminderDate: '2026-04-02',
    note: 'รอชำระยอดคงเหลือจากการผ่อนชำระ',
  },
]

export const useArrearsStore = defineStore('arrears', {
  state: () => ({
    filters: {
      search: '',
      agingGroup: '',
      contactStatus: '',
    },
    arrears,
  }),

  getters: {
    filteredArrears: (state) => {
      const keyword = state.filters.search.trim().toLowerCase()

      return state.arrears.filter((item) => {
        const searchable = [
          item.invoiceNo,
          item.residentName,
          item.unitCode,
          item.building,
          item.billingMonth,
          item.note,
        ]
          .join(' ')
          .toLowerCase()

        const matchesSearch = !keyword || searchable.includes(keyword)
        const matchesAging = !state.filters.agingGroup || item.agingGroup === state.filters.agingGroup
        const matchesContactStatus = !state.filters.contactStatus || item.contactStatus === state.filters.contactStatus

        return matchesSearch && matchesAging && matchesContactStatus
      })
    },

    totalCases: (state) => state.arrears.length,
    totalOutstanding: (state) => state.arrears.reduce((sum, item) => sum + item.totalOutstanding, 0),
    urgentCases: (state) => state.arrears.filter((item) => ['61_90', '90_plus'].includes(item.agingGroup)).length,
    escalatedCases: (state) => state.arrears.filter((item) => ['escalated', 'legal_review'].includes(item.contactStatus)).length,

    agingGroupOptions: () => [
      { label: 'ทั้งหมด', value: '' },
      { label: '1 - 30 วัน', value: '1_30' },
      { label: '31 - 60 วัน', value: '31_60' },
      { label: '61 - 90 วัน', value: '61_90' },
      { label: 'มากกว่า 90 วัน', value: '90_plus' },
    ],

    contactStatusOptions: () => [
      { label: 'ทั้งหมด', value: '' },
      { label: 'ยังไม่ติดตาม', value: 'new' },
      { label: 'ติดตามแล้ว', value: 'contacted' },
      { label: 'รับปากจะชำระ', value: 'promise_to_pay' },
      { label: 'ส่งต่อผู้บริหาร', value: 'escalated' },
      { label: 'อยู่ระหว่างพิจารณากฎหมาย', value: 'legal_review' },
    ],

    summaryByAging: (state) => {
      const groups = {
        '1_30': 0,
        '31_60': 0,
        '61_90': 0,
        '90_plus': 0,
      }
      state.arrears.forEach((item) => {
        groups[item.agingGroup] += item.totalOutstanding
      })
      return groups
    },
  },

  actions: {
    setSearch(value) {
      this.filters.search = value
    },
    setAgingGroup(value) {
      this.filters.agingGroup = value
    },
    setContactStatus(value) {
      this.filters.contactStatus = value
    },
    resetFilters() {
      this.filters.search = ''
      this.filters.agingGroup = ''
      this.filters.contactStatus = ''
    },
  },
})
